import { render, staticRenderFns } from "./choose-data-categories.vue?vue&type=template&id=94dbb44c&scoped=true"
import script from "./choose-data-categories.vue?vue&type=script&lang=js"
export * from "./choose-data-categories.vue?vue&type=script&lang=js"
import style0 from "./choose-data-categories.vue?vue&type=style&index=0&id=94dbb44c&scoped=true&lang=css"
import style1 from "./choose-data-categories.vue?vue&type=style&index=1&id=94dbb44c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94dbb44c",
  null
  
)

export default component.exports